import {AlertController, NavController, LoadingController, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {AgencyUserListPage} from "../agencyUserList/agencyUserList";

@Component({
  templateUrl: 'agencyMemberSearch.html',
  selector: 'agency-member-search-page',
})
export class AgencyMemberSearchPage {
  loginName: string;
  samount: string;
  eamount: string;
  orderData: number = 0;
  userArea: number = 0;

  constructor(private keyboard: Keyboard,private nav: NavController, private alertCtrl: AlertController, public loadingCtrl: LoadingController, private userService: UserService) {
  }

  searchFn() {
    let requestData: any = {
      loginname: this.loginName,
      samount: this.samount,
      eamount: this.samount,
      userarea: this.userArea,
      order: this.orderData
    };

    this.userService.agentUserSearch(requestData, this).then(data=> {
      if (!data["msg"]) {
        this.nav.push(AgencyUserListPage, {
          requestData: requestData,
          resList: data["reslist"],
          totalRecord: data["totalrecord"],
          abalance: data["abalance"],
          aparam4: data["aparam4"]
        });
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/agencyMemberSearch/agencyMemberSearch.ts